const Footer = ({ type }) => {
  return (
    <div className={ type === "main" ? "footer-main" : "footer-login" }>
      Copyright © GMI Aero 2022
    </div>
  );
}

export default Footer;
